import * as types from '../constants/userAttributesActionTypes';

export function requestUserAttributes() {
  return {type: types.USER_ATTRIBUTES_LOAD_REQUEST};
}

export function loadUserAttributesSuccess(data) {
  return {
    type: types.USER_ATTRIBUTES_LOAD_SUCCESS,
    attributes: data,
    receivedAt: Date.now(),
  };
}

export function loadUserAttributesFailure(error) {
  return {
    type: types.USER_ATTRIBUTES_LOAD_FAILURE,
    error,
    receivedAt: Date.now(),
  };
}
